'use client';

import useSoftpullModalEvents from '~/hooks/flp/useSoftpullModalEvents';

// Unforked — the marketing branch has no terms to refresh on softpull success.
export default function SoftpullModalEvents() {
  useSoftpullModalEvents(true);

  return null;
}
